import React from 'react';
import c from 'classnames';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import Surface from '../../../../Surface';
import { ListItemOption } from '../../../../List/ListItem';
import { getDescendentId } from '../utils';
import s from './AutoCompleteMenu.scss';
const AutoCompleteMenu = ({ menuId, items, selectedIndex, onSelectItem, className })=>{
    return(// Since this is just the menu portion of an autocomplete pattern, we expect the consumer to handle root-level key events
    /*#__PURE__*/ React.createElement(Surface, {
        className: c(s['root'], className),
        role: "listbox",
        type: ThemeSurface.TERTIARY
    }, items.map((item, index)=>/*#__PURE__*/ React.createElement(ListItemOption, {
            id: getDescendentId(menuId, index),
            key: index,
            label: item.label,
            checked: selectedIndex === index,
            onClick: ()=>onSelectItem(item),
            className: s['option']
        }))));
};
AutoCompleteMenu.displayName = 'AutoCompleteMenu';
export default AutoCompleteMenu;

//# sourceMappingURL=AutoCompleteMenu.js.map